module.exports = __webpack_public_path__ + "img/icon_customization.bcc3111b.svg";